<div class="help-wrapper">
	<div class="banner">
		<img src="/assets/images/help/help-banner.png" class="banner-img" alt="">

		<div class="banner-content">
			<img src="/assets/images/help/help-banner-icon.png" alt="" width="50px"> What can we help you with?
		</div>
	</div>

	<div class="help-body" ng-init="tab='relay'">
		<div class="container-fluid">
			<div class="row">
				<div class="col-md-12 search-panel text-center">
					<div class="src">
						<form (ngSubmit)="searchWiki(keyword)">
							<input type="text" placeholder="Search keyword & press enter" name="keyword" [(ngModel)]="keyword" tabindex="0" />
						</form>
					</div>
					<h2 class="title">Help Topics</h2>
				</div>
				<div class="col-md-6 col-sm-6 col-xs-12 help-left-panel">
					<ul class="list-inline menu-list">
						<li [ngClass]="{'active' : tab === 'relay'}" (click)="tab='relay'">
							<span>About relay</span>
							<i class="fa fa-play-circle float-right relay-margin-top-10"></i>
						</li>
						<li [ngClass]="{'active' : tab === 'project'}" (click)="tab='project'">
							<span>Create project</span>
							<i class="fa fa-play-circle float-right relay-margin-top-10"></i>
						</li>
						<li [ngClass]="{'active' : tab === 'environment'}" (click)="tab='environment'">
							<span>Create environment</span>
							<i class="fa fa-play-circle float-right relay-margin-top-10"></i>
						</li>
						<li [ngClass]="{'active' : tab === 'web-flow'}" (click)="tab='web-flow'">
							<span>Create web flow</span>
							<i class="fa fa-play-circle float-right relay-margin-top-10"></i>
						</li>
						<li [ngClass]="{'active' : tab === 'subflow'}" (click)="tab='subflow'">
							<span>Creat subflow</span>
							<i class="fa fa-play-circle float-right relay-margin-top-10"></i>
						</li>
						<li [ngClass]="{'active' : tab === 'endpoint'}" (click)="tab='endpoint'">
							<span>Create API endpoint</span>
							<i class="fa fa-play-circle float-right relay-margin-top-10"></i>
						</li>
						<li [ngClass]="{'active' : tab === 'testcase'}" (click)="tab='testcase'">
							<span>Create testcase</span>
							<i class="fa fa-play-circle float-right relay-margin-top-10"></i>
						</li>
						<li [ngClass]="{'active' : tab === 'testsuite'}" (click)="tab='testsuite'">
							<span>Create testsuite</span>
							<i class="fa fa-play-circle float-right relay-margin-top-10"></i>
						</li>
						<li [ngClass]="{'active' : tab === 'mastersuite'}" (click)="tab='mastersuite'">
							<span>Create mastersuite</span>
							<i class="fa fa-play-circle float-right relay-margin-top-10"></i>
						</li>
						<li [ngClass]="{'active' : tab === 'swagger'}" (click)="tab='swagger'">
							<span>Swagger import API</span>
							<i class="fa fa-play-circle float-right relay-margin-top-10"></i>
						</li>
						<li [ngClass]="{'active' : tab === 'validation'}" (click)="tab='validation'">
							<span>Validation of testcase</span>
							<i class="fa fa-play-circle float-right relay-margin-top-10"></i>
						</li>
						<li [ngClass]="{'active' : tab === 'perf-wiz'}" (click)="tab='perf-wiz'">
							<span>Perf wizard</span>
							<i class="fa fa-play-circle float-right relay-margin-top-10"></i>
						</li>
						<li [ngClass]="{'active' : tab === 'perf-wiz-demo'}" (click)="tab='perf-wiz-demo'">
							<span>Perf wizard demo</span>
							<i class="fa fa-play-circle float-right relay-margin-top-10"></i>
						</li>
					</ul>
				</div>
				<div class="col-md-6 col-sm-6 col-xs-12 help-right-panel">
					<div *ngIf="tab==='relay'">
						<video controls>
							<source src="/assets/help-videos/relay_teaser.mp4" type="video/mp4">
							Your browser does not support HTML5 video.
						</video>
						<div class="url">Wiki link : <a href="https://wiki.corp.adobe.com/display/Relay/Relay" target="_blank">https://wiki.corp.adobe.com/display/Relay/Relay </a></div>
					</div>
					<div *ngIf="tab==='project'">
						<video controls>
							<source src="/assets/help-videos/project.mp4" type="video/mp4">
							Your browser does not support HTML5 video.
						</video>
						<div class="url">Wiki link : <a href="https://wiki.corp.adobe.com/display/Relay/Projects" target="_blank">https://wiki.corp.adobe.com/display/Relay/Projects</a></div>
					</div>
					<div *ngIf="tab ==='environment'">
						<video controls>
							<source src="/assets/help-videos/environment.mp4" type="video/mp4">
							Your browser does not support HTML5 video.
						</video>
						<div class="url">Wiki link : <a href="https://wiki.corp.adobe.com/display/Relay/Environment+and+Mapper" target="_blank">https://wiki.corp.adobe.com/display/Relay/Environment+and+Mapper</a></div>
					</div>
					<div *ngIf="tab==='web-flow'">
						<video controls>
							<source src="/assets/help-videos/webflow.mp4" type="video/mp4">
							Your browser does not support HTML5 video.
						</video>
						<div class="url">Wiki link : <a href="https://wiki.corp.adobe.com/display/Relay/Web+Locators" target="_blank">https://wiki.corp.adobe.com/display/Relay/Web+Locators</a></div>
					</div>
					<div *ngIf="tab==='subflow'">
						<video controls>
							<source src="/assets/help-videos/subflow.mp4" type="video/mp4">
							Your browser does not support HTML5 video.
						</video>
						<div class="url">Wiki link : <a href="https://wiki.corp.adobe.com/display/Relay/Web+Sub+Flow" target="_blank">https://wiki.corp.adobe.com/display/Relay/Web+Sub+Flow</a></div>
					</div>
					<div *ngIf="tab==='endpoint'">
						<video controls>
							<source src="/assets/help-videos/endpoint.mp4" type="video/mp4">
							Your browser does not support HTML5 video.
						</video>
						<div class="url">Wiki link : <a href="https://wiki.corp.adobe.com/display/Relay/Endpoint" target="_blank">https://wiki.corp.adobe.com/display/Relay/Endpoint</a></div>
					</div>
					<div *ngIf="tab==='testcase'">
						<video controls>
							<source src="/assets/help-videos/testcase.mp4" type="video/mp4">
							Your browser does not support HTML5 video.
						</video>
						<div class="url">Wiki link : <a href="https://wiki.corp.adobe.com/display/Relay/Testcase" target="_blank">https://wiki.corp.adobe.com/display/Relay/Testcase</a></div>
					</div>
					<div *ngIf="tab==='testsuite'">
						<video controls>
							<source src="/assets/help-videos/testsuite.mp4" type="video/mp4">
							Your browser does not support HTML5 video.
						</video>
						<div class="url">Wiki link : <a href="https://wiki.corp.adobe.com/display/Relay/Testuite" target="_blank">https://wiki.corp.adobe.com/display/Relay/Testsuite </a></div>
					</div>
					<div *ngIf="tab==='swagger'">
						<video controls>
							<source src="/assets/help-videos/swagger.mp4" type="video/mp4">
							Your browser does not support HTML5 video.
						</video>
						<div class="url">Wiki link : <a href="https://wiki.corp.adobe.com/display/Relay/Swagger+Integration" target="_blank">https://wiki.corp.adobe.com/display/Relay/Swagger+Integration</a></div>
					</div>
					<div *ngIf="tab==='validation'">
						<video controls>
							<source src="/assets/help-videos/validation.mp4" type="video/mp4">
							Your browser does not support HTML5 video.
						</video>
						<div class="url">Wiki link : <a href="https://wiki.corp.adobe.com/display/Relay/Testcase#Testcase-Validations" target="_blank">https://wiki.corp.adobe.com/display/Relay/Testcase#Testcase-Validations</a></div>
					</div>
					<div *ngIf="tab==='perf-wiz'">
						<video controls>
							<source src="/assets/help-videos/perfWizz_teaser.mp4" type="video/mp4">
							Your browser does not support HTML5 video.
						</video>
						<div class="url">Wiki link : <a href="https://wiki.corp.adobe.com/display/Relay/Performance+Wizard" target="_blank">https://wiki.corp.adobe.com/display/Relay/Performance+Wizard</a></div>
					</div>
					<div *ngIf="tab==='perf-wiz-demo'">
						<video controls>
							<source src="/assets/help-videos/perfWizz_demo.mp4" type="video/mp4">
							Your browser does not support HTML5 video.
						</video>
						<div class="url">Wiki link : <a href="https://wiki.corp.adobe.com/display/Relay/Performance+Wizard" target="_blank">https://wiki.corp.adobe.com/display/Relay/Performance+Wizard</a></div>
					</div>

				</div>
			</div>
		</div>
	</div>
</div>